import Vue from 'vue'
import { ToastPlugin, ModalPlugin }  from 'bootstrap-vue';
import VueCompositionAPI from '@vue/composition-api'
import { BootstrapVue, BootstrapVueIcons  } from 'bootstrap-vue';


// main.js
import VueSweetalert2 from 'vue-sweetalert2'





// Global Components
import './global-components'
import i18n from '@/libs/i18n'
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


/* import specific icons */
import {
  faUserSecret, faBirthdayCake, faMagnifyingGlass, faFileExcel, faFilePdf, faCirclePlus, faMinusCircle, faWrench,
  faChartBar, faCircleCheck, faCircleXmark, faUserNurse, faFolderPlus, faUser, faUserPlus, faEdit, faPaste, faUserEdit, faCarSide,
  faPencilSquare, faRecycle, faRemove, faUserPen, faDeleteLeft, faCloudDownload, faChevronDown, faMagnifyingGlassChart, 
  faProcedures, faFlask, faMicroscope, faCapsules, faPrescriptionBottleAlt, faUserMd, faHeart, faNotesMedical, faStethoscope
} from '@fortawesome/free-solid-svg-icons'

// 3rd party plugins
import '@axios'
// import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

import VueCookie from 'vue-cookie'
import App from './App.vue'
import store from './store'
import router from './router'

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css'
import { applyApiEnvironment, getStoredApiEnvironment } from '@/shared/helpers'

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueSweetalert2);

Vue.use(VueCookie)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

/* import the fontawesome core */

library.add(faUserSecret, faBirthdayCake, faMagnifyingGlass, faFileExcel, faFilePdf, faCirclePlus, faMinusCircle, 
  faWrench, faChartBar, faCircleCheck, faCircleXmark, faFolderPlus, faMagnifyingGlassChart, faRecycle, faPaste,  faUser, faUserPlus, faEdit, faUserEdit, faUserPen, faCloudDownload, faChevronDown,
  faCarSide, faPencilSquare, faRemove, faDeleteLeft,  faProcedures,  faFlask,  faMicroscope,  faCapsules, faPrescriptionBottleAlt, faUserMd, faHeart, faNotesMedical, faStethoscope)


  
/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueSweetalert2)


const validateExperationSession = () => {

  const user = localStorage.getItem('usuario');
  if (user) {
    const parsedUser = JSON.parse(user);
    const fechaLogin = parsedUser.code;
    if (!fechaLogin) {
      localStorage.removeItem('usuario');
      return;
    }


    const loginDate = new Date(fechaLogin);
    loginDate.setHours(0, 0, 0, 0)
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (loginDate.getTime() !== today.getTime()){
      localStorage.removeItem('usuario');
      localStorage.clear();
    }
      
    
  }
}

validateExperationSession();
applyApiEnvironment(getStoredApiEnvironment())


// AQUI SE VERIFICAN LOS PERMISOS PARA CADA RUTA comparando el storage con la configuracion de meta.permiso de la ruta especificada en router.js Paso #2
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('usuario') === null) {
      next({
        name: 'login',
      })
    } else {
      next()
    }
  } else {
    next()
  }
});


new Vue({
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',
  render: h => h(App),
}).$mount('#app')
